import { render, staticRenderFns } from "./NewQuestionDropdown.vue?vue&type=template&id=f2e0f066&scoped=true"
import script from "./NewQuestionDropdown.vue?vue&type=script&lang=js"
export * from "./NewQuestionDropdown.vue?vue&type=script&lang=js"
import style0 from "./NewQuestionDropdown.vue?vue&type=style&index=0&id=f2e0f066&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e0f066",
  null
  
)

export default component.exports